var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0926 0.710449C5.74602 0.710449 3.03308 3.42339 3.03308 6.76997C3.03308 9.21059 4.47598 11.3142 6.55527 12.2743C4.97357 12.5977 3.59375 13.2594 2.50794 14.3294C0.87119 15.9425 0.0616455 18.3266 0.0616455 21.3861C0.0616455 21.9384 0.509361 22.3861 1.06165 22.3861C1.61393 22.3861 2.06165 21.9384 2.06165 21.3861C2.06165 18.6633 2.77793 16.8714 3.91181 15.7539C5.04864 14.6336 6.76456 14.0339 9.09252 14.0339C11.4205 14.0339 13.1365 14.6336 14.2733 15.7539C15.4073 16.8714 16.1236 18.6633 16.1235 21.3861C16.1235 21.9384 16.5712 22.3861 17.1235 22.3861C17.6758 22.3861 18.1235 21.9384 18.1235 21.3861C18.1236 18.3266 17.314 15.9425 15.6772 14.3294C14.5914 13.2594 13.2116 12.5978 11.6299 12.2743C13.7092 11.3142 15.1521 9.21061 15.1521 6.76997C15.1521 3.42339 12.4392 0.710449 9.0926 0.710449ZM5.03308 6.76997C5.03308 4.52796 6.85059 2.71045 9.0926 2.71045C11.3346 2.71045 13.1521 4.52796 13.1521 6.76997C13.1521 9.01199 11.3346 10.8295 9.0926 10.8295C6.85059 10.8295 5.03308 9.01199 5.03308 6.76997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.368993dc1b2d7b22d0764b3f8a2e0e33.svg";
export { ForwardRef as ReactComponent };